<template>
  <div id="twitter">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "App",
};
</script>

<style lang="scss">
  @import "assets/style/_reset.scss";
  @import "assets/style/vue-modal.css";
</style>
